<template>
  <div
    class="button-menu-wrapper"
    @click.stop="$emit('selectedTemplate', template)"
  >
    <div class="button-menu button-template-container center-x">
      <img
        :src="template.preview"
      >
        <div class="flex vertical center-y mt-8">
        <span class="button-menu-label full" v-if="label">{{label}}</span>
        <sw-button
          class="button-top-icon full button-template-delete"
          font="fa"
          icon="trash"
          @click.native.stop.prevent="$emit('removeTemplate', template)"
          v-if="showDelete"
          :selectable=false
        >
          <span class="delete-label">supprimer</span>
        </sw-button>
      </div>
      </div>
    </div>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////
import {mapGetters} from 'vuex'
//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'ButtonMenu',
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {}
  },
  props: {
    iconClass: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    isNew: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    template: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['getLimitations']),
    showDelete(){
      if(!this.template.public){
        return true
      }
      return this.template.public && this.getLimitations.templatePublicCreator
    },
    getUrlPreview() {
      return this.template.preview ? `background-image:url(${this.template.preview})` : ''
    }
  },
  methods: {
    test(v) {}
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/buttons/ButtonTemplate.vue